<template>
  <a-spin :spinning="loadingDuplicateMail">
    <div>
      <a-form :form="formulario" layout="vertical" @submit="handleSubmit">
        <a-row type="flex" :gutter="40">
          <a-col :span="24" class="titulo" v-if="$route.name == 'actualizar'">Actualizar Email</a-col>
          <a-col :span="24" class="titulo" v-if="$route.name == 'duplicar'">Duplicar Email</a-col>
          <a-col :span="24" class="titulo" v-if="$route.name == 'reenviar'">Reenviar Email</a-col>
          <a-col :span="24" class="titulo" v-if="$route.name == 'crear'">Crear Nuevo Email</a-col>
          <a-col :span="24">
            <a-row type="flex" :gutter="80">
              <a-col :span="12">
                <!-- Nombre -->
                <a-form-item>
                  <span slot="label">
                    Nombre&nbsp;
                    <a-tooltip title="Nombre de email">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <a-input size="large" v-decorator="['nombre', formularioRules.nombre]" class="shadowInputs" />
                </a-form-item>
                <!-- País -->
                <a-form-item>
                  <span slot="label">
                    País&nbsp;
                    <a-tooltip title="Seleccione el país al cual el email será enviado.">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <a-select v-on:change="paisSeleccionado" size="large" v-decorator="['id_pais', formularioRules.nombre]" class="shadowInputs">
                    <a-select-option v-for="itemPais in PAISES" :key="'pais_' + itemPais.id" :value="parseInt(itemPais.id)">
                      {{itemPais.emoji}} {{ itemPais.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <!-- Categoría -->
                <a-form-item>
                  <span slot="label">
                    Categoría&nbsp;
                    <a-tooltip title="Seleccione la categoría a la que pertenece este email.">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <a-select size="large" v-decorator="['categoryId', formularioRules.categoryId]"
                            class="shadowInputs">
                    <a-select-option v-for="itemCategoria in CATEGORIAS" :key="'categoria_' + itemCategoria.id"
                                     :value='itemCategoria.id' v-if="itemCategoria.main != '1'">
                      {{ itemCategoria.name }}
                    </a-select-option>
                  </a-select>

                </a-form-item>
                <!-- Fecha y hora de Envios -->

                <a-form-item style="margin-bottom: 0px;">
                  <span slot="label">
                    Fecha y Hora de Envio&nbsp;
                    <a-tooltip title="Seleccione la fecha y la hora en la que se debe mandar el email.">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <a-row type="flex" justify="space-between" align="bottom" :gutter="15" class="wrapped_inputs">
                    <a-col :span="12">
                      <a-form-item label="Fecha" class="">
                        <a-date-picker size="large" class="shadowInputs" style="width: 100%" mode="time"
                          format="D MMMM YYYY" placeholder="Seleccionar fecha"
                          v-decorator="['fecha_envio', { rules: [{ type: 'object', required: !form.enviar_ahora, message: 'Seleccione la fecha de envio' }] }]"
                          :disabled="form.enviar_ahora" :disabledDate="disabledStartDate" />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-item label="Hora" class="">
                        <a-time-picker size="large" class="shadowInputs" placeholder="Selecionar hora" style="width: 100%"
                          format="HH:mm" :minuteStep="10"
                          v-decorator="['hora_envio', { rules: [{ type: 'object', required: !form.enviar_ahora, message: 'Seleccione la fecha de envio' }] }]"
                          :disabled="form.enviar_ahora" />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-item style="margin-bottom: -2px;">
                        <a-checkbox style="font-size: 14px; font-weight: 400" :checked="form.enviar_ahora"
                          @change="form.enviar_ahora = !form.enviar_ahora">Enviar ahora</a-checkbox>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-form-item>
                <!-- From Name -->
                <a-form-item>
                  <span slot="label">
                    From Name&nbsp;
                    <a-tooltip title="El from name es el nombre del remitente.">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <a-input size="large" v-decorator="['from_name', formularioRules.from_name]" class="shadowInputs" />
                </a-form-item>
                <!-- From Mail -->
                <a-form-item >
                  <span slot="label">
                    From Mail&nbsp;
                    <a-tooltip title="El from mail es el correo del remitente.">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <a-input v-decorator="['from_mail', formularioRules.from_mail]" class="shadowInputs" size="large" />
                </a-form-item>
                <!-- Reply to -->
                <a-form-item >
                  <span slot="label">
                    Reply To&nbsp;
                    <a-tooltip title="El reply to es el correo que recibe respuesta.">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <a-input v-decorator="['reply_to', formularioRules.reply_to]" class="shadowInputs" size="large" />
                </a-form-item>


                <a-form-item>
                  <span slot="label">
                    Variables
                    <a-tooltip title="Variables a ser utilizadas en el mail. Las variables de usuario tienen prioridad sobre estas variables">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>

                  <template style="padding: 0;margin: 0" v-for="key in form.variablesCount">
                    <a-col :span="12">
                      <a-input :placeholder="'Variable ' + (key)" size="large" v-decorator="['variable[' + (key-1) + ']', formularioRules.variable]" class="shadowInputs" />
                    </a-col>
                    <a-col :span="12">
                      <a-input :placeholder="'Valor ' + (key)" size="large" v-decorator="['valorVariable[' + (key-1) + ']', formularioRules.valorVariable]" class="shadowInputs" />
                    </a-col>
                  </template>
                  <a-button v-if="form.variablesCount > 0" size="large" icon="minus" @click="form.variablesCount--"/>
                  <a-button size="large" icon="plus" @click="form.variablesCount++"/>


                </a-form-item>

              </a-col>

              <a-col :span="12">
                <a-form-item style="text-align: left">
                  <span slot="label">
                    AB test de asuntos
                     <a-tooltip title="Ingrese varios asuntos para enviar al 10% de la base. Una hora despues se enviara el email al resto de la base con el asunto ganador">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <a-switch v-model:checked="form.abtest" />
                </a-form-item>
                <!-- Asunto -->
                <a-form-item>
                  <span slot="label">
                    {{ form.abtest ? 'Asuntos' : 'Asunto' }}&nbsp;
                    <a-tooltip title="Ingrese el asunto de este email">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <a-input placeholder="Asunto" size="large" v-decorator="['asunto', formularioRules.asunto]"
                    class="shadowInputs" />

                </a-form-item>

                <template v-if="form.abtest">
                  <a-form-item style="padding: 0;margin: 0" v-for="key in form.subjectCount - 1">
                    <a-input :placeholder="'Asunto ' + (key+1)" size="large" v-decorator="['subjectList[' + (key-1) + ']', formularioRules.asunto]" class="shadowInputs" />
                  </a-form-item>
                  <a-button v-if="form.subjectCount > 2" size="large" icon="minus" @click="form.subjectCount--"/>
                  <a-button size="large" icon="plus" @click="form.subjectCount++"/>
                </template>

                <!-- Auto Refuerzo-->
                <a-divider/>
                <a-form-item style="text-align: left">
                  <span slot="label">
                    Refuerzo Automático
                    <a-tooltip title="Activar para reenviar automaticamente a quienes no abren el correo">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <a-switch v-model:checked="form.reenvio" />
                  <template v-if="form.reenvio">
                    <a-input placeholder="Asunto Refuerzo" v-decorator="['asunto_reenvio', formularioRules.asunto_reenvio]"></a-input>
                    Se enviará
                    <a-select @change="(e)=>form.dias_reenvio = e" style="width: 100px" v-decorator="['dias_reenvio', formulario.dias_reenvio]">
                      <a-select-option v-for="day in [1,2,3,4,5,6,7]" :key="day" :value="day" :title="day">
                        {{ day }}
                      </a-select-option>
                    </a-select>
                    días después
                    <br/>
                    <a-checkbox v-if="parseInt(form.dias_reenvio) > 1" style="" :checked="form.reenvio_misma_hora"
                                @change="form.reenvio_misma_hora = !form.reenvio_misma_hora">A la misma hora</a-checkbox>
                    <br/>
                    <br/>
                    <a-time-picker v-if="!form.reenvio_misma_hora && parseInt(form.dias_reenvio) > 1" size="large" class="shadowInputs" placeholder="Selecionar hora" style="width: 100%"
                                   format="HH:mm" :minuteStep="10"
                                   v-decorator="['hora_reenvio', { rules: [{ type: 'object', required: !form.reenvio_misma_hora, message: 'Seleccione la hora de reenvio' }] }]"
                                    />

                  </template>
                </a-form-item>
                <a-divider/>

                <!-- HTML Validator -->
                <a-form-item style="text-align: left">
                  <span slot="label">
                    Versión AMP
                    <a-tooltip title="Activar para incluir versión AMP">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <a-switch v-model:checked="form.includeAmp" />
                  <template v-if="form.includeAmp">
                    <a-textarea @change="onValidateAmp" style="margin: 10px 0" placeholder="AMP html" :autosize="{ minRows: 3, maxRows: 7 }"
                    v-decorator="['ampContent']" class="shadowInputs" />
                    <template v-if="ampErrors.length && !ampIsValid">
                      <span style="color: #ed4d4d;font-size: 12px;"><a-icon type="close"></a-icon>&nbsp;El html ingresado no tiene un formato AMP válido</span>
                      <br/>
                      <template v-for="error in ampErrors">
                        <span style="color: #ed4d4d;font-size: 12px;"><a-icon type="close"></a-icon>&nbsp;{{ error }}</span>
                        <br/>
                      </template>
                    </template>
                    <template v-if="ampIsValid">
                      <span style="color: green;font-size: 12px;"><a-icon type="check"></a-icon>&nbsp;El html ingresado tiene un formato AMP válido</span>
                    </template>
                  </template>
                </a-form-item>
                <a-divider/>
                <!-- Preview Text -->
                <a-form-item>
                  <span slot="label">
                    Preview Text&nbsp;
                    <a-tooltip title="Ingrese el texto de previsualización de email.">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <a-textarea placeholder="Preview Text" :autosize="{ minRows: 3, maxRows: 7 }"
                    v-decorator="['preview_text']" class="shadowInputs" />
                </a-form-item>
                <a-divider/>
                <!-- Contenido -->
                <a-form-item>
                  <span slot="label">
                    Contenido&nbsp;
                    <a-tooltip title="Seleccione o busque el template de mandrill para este email">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <div style="display: flex; justify-content: space-between">
                    <a-select size="large" class="shadowInputs" showSearch allowClear
                      v-decorator="['template_id', formularioRules.template_id]"
                      placeholder="Ingrese el nombre del template" optionFilterProp="title"
                      style="width: calc(100% - 110px)">
                      <a-select-option v-for="itemTemplate in templates" :key="'template_' + itemTemplate.id"
                        :value="itemTemplate.id" :title="itemTemplate.name">
                        {{ itemTemplate.name }}
                      </a-select-option>
                    </a-select>
                    <a-tooltip title="Recargar lista de templates">
                      <a-button shape="circle" size="large" icon="reload" @click="recargarTemplates()" />
                    </a-tooltip>
                    <a-tooltip title="Previsualizar Template">
                      <a-button shape="circle" size="large" icon="eye" @click="previewTemplate()"
                        :disabled="typeof this.formulario.getFieldValue('template_id') == 'undefined'" />
                    </a-tooltip>
                  </div>
                </a-form-item>

                <!-- Base de Datos -->
                <a-form-item style="margin-bottom: 10px;">
                  <a-row slot="label" type="flex" justify="space-between" align="middle">
                    <a-col :span="16">Base de Datos</a-col>
                    <a-col>
                      <a-spin :spinning="loadingCountLista"><detailHover titulo="#Personas" :valor="format_number(form.cantidad_personas)" /></a-spin>
                    </a-col>
                    <a-col>
                      <a-spin :spinning="loadingCountLista"><detailHover titulo="Costo" :valor="format_number(form.costo_aprox)" /></a-spin>
                    </a-col>
                  </a-row>

                  <a-form-item>
                    <span slot="label">
                      Listas Principales&nbsp;
                      <a-tooltip title="Seleccione las listas a las que se enviara este email.">
                        <a-icon type="question-circle-o" />
                      </a-tooltip>
                    </span>
                    <a-select size="large" mode="multiple" class="shadowInputs" v-decorator="['id_listas_incluir']"
                      notFoundContent="No exiten Listas para el pais seleccionado" optionFilterProp="title"
                      @change="actualizarCantCosto()">
                      <a-select-option class="shadowInputs" v-for="itemLista in listas_to_show"
                        :key="'listaIncluir_' + itemLista.id" :value="itemLista.id" :title="itemLista.nombre">
                        <b>{{ itemLista.nombre }}</b> - {{ itemLista.cantidad + ' contactos' }} - {{
                          itemLista.modificado_el
                        }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-row type="flex" justify="space-between" align="top" :gutter="20">
                    <a-col :span="12">
                      <a-form-item style="width: 100%">
                        <span slot="label">
                          Excluir Listas&nbsp;
                          <a-tooltip
                            title="Seleccione las listas que se quieren excluir de este email para que no reciban este email.">
                            <a-icon type="question-circle-o" />
                          </a-tooltip>
                        </span>
                        <a-select size="large" class="shadowInputs" mode="multiple"
                          notFoundContent="No exiten Listas para el pais seleccionado" v-decorator="['id_listas_excluir']"
                          optionFilterProp="title" @change="actualizarCantCosto()">
                          <a-select-option v-for="itemLista in listas_excluir_to_show"
                            :key="'listaExcluir_' + itemLista.id" :value="itemLista.id" :title="itemLista.nombre">
                            <b>{{ itemLista.nombre }}</b> - {{ itemLista.cantidad + ' contactos' }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item style="width: 100%">
                        <span slot="label">
                          Excluir Email&nbsp;
                          <a-tooltip title="Seleccione los email que se quieren excluir para que no reciban este email.">
                            <a-icon type="question-circle-o" />
                          </a-tooltip>
                        </span>
                        <a-select size="large" class="shadowInputs" mode="multiple" v-decorator="['id_mailings_excluir']"
                          notFoundContent="No exiten mailing para el pais seleccionado" optionFilterProp="title"
                          @change="actualizarCantCosto()">
                          <a-select-option v-for="itemMail in mailings" :key="'mailingExcluir_' + itemMail.id"
                            :value="itemMail.id" :title="itemMail.nombre">
                            <b>{{ itemMail.nombre }}</b> - {{ itemMail.cantidad_envios + ' contactos' }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-form-item>
                <a-form-item>
                  <a-row type="flex" justify="end" align="middle" :gutter="20">

                    <a-col v-if="$route.name == 'actualizar'">
                      <a-button :loading="loadingCreate" size="large" class="shadowInputs" type="primary" html-type="submit">Actualizar
                        Email</a-button>
                    </a-col>

                    <a-col v-if="$route.name == 'duplicar'">
                      <a-button :loading="loadingCreate" size="large" class="shadowInputs" type="primary" html-type="submit">Duplicar
                        Email</a-button>
                    </a-col>

                    <a-col v-if="$route.name == 'reenviar'">
                      <a-button :loading="loadingCreate" size="large" class="shadowInputs" type="primary" html-type="submit">Crear
                        Reenvío</a-button>
                    </a-col>

                    <a-col v-if="$route.name == 'crear'">
                      <a-button :loading="loadingCreate" size="large" class="shadowInputs" type="primary" html-type="submit">Crear Email</a-button>
                    </a-col>

                    <span v-if="form.cantidad_personas < 0" class="comentarios">No es posible guardar, ya que el total de
                      personas es negativo.</span>
                    <span v-if="form.estado != 'BORRADOR'" class="comentarios">Al modificar información del email, el
                      mismo debe volvera a pasar por todo el proceso de aprobación.</span>
                  </a-row>
                </a-form-item>
              </a-col>

            </a-row>
          </a-col>
        </a-row>
      </a-form>

      <a-drawer :title="templateOpened.template.nombre" placement="right" @close="templateOpened.isOpen = false"
        :visible="templateOpened.isOpen" width="40%">
        <div v-html="templateOpened.template.html">
          {{ templateOpened.template.html }}
        </div>
      </a-drawer>

      <a-modal title="Ingrese los email que recibirán una prueba" v-model="visibleSendTest">
        <a-textarea v-model="form.sendTestEmails"
          placeholder="Ingrese los email que recibirán la prueba separados por comas"
          :autosize="{ minRows: 2, maxRows: 6 }" />
        <template slot="footer">
          <a-button key="back" @click="visibleSendTest = false">Cerrar</a-button>
          <a-button @click="sendTestEmail()" type="primary">Enviar Prueba</a-button>
        </template>
      </a-modal>
    </div>
  </a-spin>
</template>


<script>
import moment from 'moment'
import detailHover from '../components/DetailHover.vue'
import utils from '../service/service.js'
import amphtmlValidator from 'amphtml-validator'
import categories from "@/service/categories";
import countries from "@/service/countries";
export default {
  name: 'formulario',
  components: {
    detailHover,
  },
  props: ['idMail'],
  mixins: [utils, categories, countries],
  data() {
    return {
      loadingCountLista: false,
      visibleSendTest: false,
      loadingDuplicateMail: false,
      form: {
        /*id: '',
        accion: 'crear', // puede ser 'crear', 'duplicar' o 'actualizar' o 'reenviar'*/
        sendTestEmails: '',
        enviar_ahora: false,
        cantidad_personas: 0,
        costo_aprox: 0,
        from_mail_suggest: '',
        reply_to_mail_suggest: '',
        estado: 'BORRADOR', // por defecto es borrador, si se va a editar se le pasa el valor del este del email antes
        id_listas_incluir: [],
        id_mailings_excluir: [],
        abtest: false,
        subjectCount: 2,
        variablesCount: 0,
        includeAmp: false,
        reenvio: false,
        asunto_reenvio: '',
        dias_reenvio: 1,
        reenvio_misma_hora: true,
        hora_reenvio: null,

      },
      formularioRules: {
        nombre: { rules: [{ required: true, message: 'Ingrese un nombre para este Email' }] },
        pais: { rules: [{ required: true, message: 'Seleccione un país al que se le enviara este Email' }] },
        categoryId: { rules: [{ required: true, message: 'Seleccione la categoría de este Email' }] },
        //fecha_envio: { rules: [{ type: 'object', required: this.enviar_ahora, message: 'Seleccione la fecha de envio' }] },
        from_name: { rules: [{ required: true, message: 'Ingrese el from name de este Email' }] },
        from_mail: {
          rules: [{ required: true, message: 'Ingrese el from mail de este Email' },
          { type: 'email', message: 'Ingrese un correo válido.' }]
        },
        reply_to: {
          rules: [{ required: true, message: 'Ingrese el reply to de este Email' },
          { type: 'email', message: 'Ingrese un correo válido.' }]
        },
        asunto: { rules: [{ required: true, message: 'Ingrese el asunto de este Email' }] },
        template_id: { rules: [{ required: true, message: 'Ingrese el nombre del template de mandrill para este email' }] },
        //listas_incluir: { rules: [{ required: true, message: 'Seleccione las listas de inclusión' }] },
        hora_envio: { rules: [{ type: 'object', required: true, message: 'Seleccione la hora de envio' }] },
        variable: {rules:[{required:true, message:'La variable debe tener un nombre'}]},
        valorVariable: {rules:[{required:false}]},
        asunto_reenvio: {rules:[{required: true}]},
        dias_reenvio: {rules:[{required: true}]},
      },
      templateOpened: {
        template: {},
        isOpen: false,
      },

      listas: [],
      listas_to_show: [],
      listas_excluir_to_show: [],
      listas_de_pais: [],
      NewId: 0,


      templates: [],
      mailings: [],
      formulario: null,
      ampIsValid: false,
      ampErrors: [],
      loadingCreate: false,
    }
  },
  created() {
    this.formulario = this.$form.createForm(this);
  },
  mounted: function () {
    this.recargarTemplates();

    if (this.$route.name == 'actualizar') {
      this.updateMailing(this.idMail).then(()=>{
        this.getMailings();
      });
    } else if (this.$route.name == 'duplicar') {
      this.duplicateMailing(this.idMail).then(()=>{
        this.getMailings();
      });
    } else if (this.$route.name == 'reenviar') {
      this.resendMailing(this.idMail).then(()=>{
        this.getMailings();
      });
    }
  },
  methods: {
    paisSeleccionado: function (idPais) {
      var $this = this;

      $this.formulario.setFieldsValue({
        ['id_mailings_excluir']: [],
        ['id_listas_incluir']: [],
        ['id_listas_excluir']: []
      });
      setTimeout(()=>{
        this.actualizarCantCosto();
        this.getMailings();
        this.getListas(idPais);
      }, 200)


    },
    async onValidateAmp(){

      setTimeout(async () => {
        this.ampErrors = [];

        const content = this.formulario.getFieldsValue()['ampContent'];
        if (content === '') {
          this.ampIsValid = null;
          return;
        }
        const validator = await amphtmlValidator.getInstance("https://cdn.ampproject.org/v0/validator.20211101.deprecated.js");


        const result = validator.validateString(content, 'AMP4EMAIL');

        for (var ii = 0; ii < result.errors.length; ii++) {
          const error = result.errors[ii];
          if(error.message.includes('The relative URL')) {
            continue;
          }
          let msg = 'line ' + error.line + ', col ' + error.col + ': ' + error.message;
          if (error.specUrl !== null) {
            msg += ' (see ' + error.specUrl + ')';
          }
          this.ampErrors.push(msg);
          //(error.severity === 'ERROR' ? console.error : console.warn)(msg);
        }

        this.ampIsValid = this.ampErrors.length <= 0;

      }, 200)


    },
    async recargarTemplates() {
      const { data } = await this.sendRequest({
        method: 'GET',
        url: 'templates/list',
      })
      this.templates = data;
    },
    async previewTemplate() {
      var $this = this;
      var slug = this.formulario.getFieldValue('template_id');
      const { data } = await this.sendRequest({
        method: 'GET',
        url: `templates/render/${slug}`,
      })
      $this.templateOpened.template.html = data;
      $this.templateOpened.isOpen = true;
      this.loading = true;
    },
    format_number(num) {
      if (!isNaN(num)) {
        num = parseInt(num);
        return new Intl.NumberFormat().format(num);
      } else
        return '-'
    },
    textHelpDate() {
      var res = "";
      var today = new Date();
      if (typeof this.formulario.getFieldValue('fecha_envio') != 'undefined') {
        if (this.formulario.getFieldValue('fecha_envio') < today) {
          res = "La fecha seleccionada es previa a hoy";
        }
      }
      return res;
    },
    async actualizarCantCosto() {
      var $this = this;
      setTimeout(function() {
        const id_listas_incluir = $this.formulario.getFieldValue('id_listas_incluir');
        const id_listas_excluir = $this.formulario.getFieldValue('id_listas_excluir');
        const id_mailings_excluir = $this.formulario.getFieldValue('id_mailings_excluir');
        let info = {};
        if (id_listas_incluir !== 'undefined') {
          $this.listas_excluir_to_show = $this.listas_de_pais.filter(x => {
            return !$this.formulario.getFieldValue('id_listas_incluir').includes(x["id"]);
          });
          info['id_listas_incluir'] = $this.formulario.getFieldValue('id_listas_incluir');
        }
        if (id_listas_excluir !== 'undefined') {
          $this.listas_to_show = $this.listas_de_pais.filter(x => {
            return !$this.formulario.getFieldValue('id_listas_excluir').includes(x["id"]);
          });
          info['id_listas_excluir'] = $this.formulario.getFieldValue('id_listas_excluir');
        }
        if (id_mailings_excluir !== 'undefined') {
          info['id_mailings_excluir'] = $this.formulario.getFieldValue('id_mailings_excluir');
        }
        $this.loadingCountLista = true;
        $this.sendRequest({
          method: 'POST',
          url: 'listas/count',
          data: { info }
        }).then(({data}) => {
          $this.loadingCountLista = false;
          $this.form.cantidad_personas = data.cantidad_envios;
          $this.form.costo_aprox = data.costo;
        })
      }, 200)

    },
    disabledStartDate(current) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      return current && current.valueOf() <= today;
    },

    /* guardadr */
    handleSubmit(e) {

      console.log(this.formulario.getFieldsValue())
      var $this = this;
      e.preventDefault();

      this.formulario.validateFields(
        async (err) => {
          if (!err) {
            this.loadingCreate = true;
            var $info = this.formulario.getFieldsValue();
            $info['reenvio'] = this.form.reenvio;
            if (!$this.form.enviar_ahora) {
              $info['fecha_envio'] = $info['fecha_envio'].format('YYYY-MM-DD') + ' ' + $info['hora_envio'].format('HH:mm:ss');
              delete $info['hora_envio'];
            } else {
              var current_datetime = new Date()
              let formatted_date = current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate() + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes() + ":" + current_datetime.getSeconds()
              $info['fecha_envio'] = formatted_date;
            }

            if($this.form.reenvio && $this.form.dias_reenvio > 1 && !$this.form.reenvio_misma_hora) {
              $info['hora_reenvio'] = $info['hora_reenvio'].format('HH:mm:ss');
            }

            let url = "";
            if ($this.$route.name == 'actualizar' || $this.$route.name == 'duplicar' || $this.$route.name == 'reenviar') {
              var id;
              $this.$route.name == 'actualizar' ? id = this.idMail : id = this.NewId;
              url = `mailings/update/${id}`;
            } else {
              url = "mailings/new";
            }
            await this.sendRequest({
              method: 'POST',
              url: url,
              data: {
                info: $info
              }
            })
            this.loadingCreate = false;
            this.$router.push('/panel/listado');
          }
        },
      );
    },
    async getListas(idPais) {
      var $this = this;
      const { data } = await this.sendRequest({
        method: 'GET',
        url: 'listas',
      })
      $this.listas = data;
      $this.listas_de_pais = $this.listas.filter(x => {
        return x.id_pais == idPais;
      })
      $this.listas_excluir_to_show = $this.listas_de_pais;
      $this.listas_to_show = $this.listas_de_pais;
    },
    async getMailings() {
      var $this = this;
      const id_pais = $this.formulario.getFieldValue('id_pais');
      if (id_pais === undefined) {
        return false;
      }
      const filtros = {
        pais: [id_pais],
      };
      const { data } = await this.sendRequest({
        method: 'POST',
        url: 'mailings/list',
        data: {
          filters: filtros
        },
      })
      this.mailings = data.mailings;
    },
    /* carga el actualizar no actualiza */
    async updateMailing($id) {
      var $this = this;
      const { data } = await this.sendRequest({
        method: 'GET',
        url: `mailings/${$id}`,
      })
      $this.loadMailing(data);
    },
    async duplicateMailing($id) {
      this.loadingDuplicateMail = true;
      const { data } = await this.sendRequest({
        method: 'POST',
        url: `mailings/duplicate/${$id}`,
      })
      this.loadingDuplicateMail = false;
      this.loadMailing(data);
      this.NewId = data.id;
    },
    async resendMailing($id) {
      var $this = this;
      const { data } = await this.sendRequest({
        method: 'POST',
        url: `mailings/resend/${$id}`,
      })
      $this.loadMailing(data);
      this.NewId = data.id;
    },
    async loadMailing(data) {

      const sleep = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms))
      }


      var $this = this;
      if (typeof data.cantidad_envios != 'undefined') $this.form.cantidad_personas = data.cantidad_envios;
      if (typeof data.costo != 'undefined') $this.form.costo_aprox = data.costo;
      if (typeof data.estado != 'undefined') $this.form.estado = data.estado;

      this.getListas(data.id_pais);

      if (typeof data.fecha_envio != 'undefined') {
        data['hora_envio'] = moment(data.fecha_envio);
        data['fecha_envio'] = moment(data.fecha_envio);
      }

      data['id_pais'] = parseInt(data['id_pais']);
      // cargo solo los campos que estan defeinidos en el formulario
      $this.form.includeAmp = data.ampContent != null;
      $this.form.reenvio = data.reenvio;
      $this.form.dias_reenvio = data.dias_reenvio
      $this.form.reenvio_misma_hora = data.hora_reenvio === null
      if(data.hora_reenvio != null) {
        data.hora_reenvio = moment('2023-01-01 ' + data.hora_reenvio);
      }

      await sleep(200); //es necesario esperar para que el formulario actualice luego de cambiar el campo ampContent

      var campos = Object.keys($this.formulario.getFieldsValue());
      var info = {};
      campos.forEach(function (key) {
        if (typeof data[key] != 'undefined') info[key] = data[key];
      });

      $this.form.abtest = data.abtest;
      $this.form.hora_reenvio = data.hora_reenvio
      info.hora_reenvio = data.hora_reenvio

      if ($this.form.abtest && data.subjectList && data.subjectList.length) {
        $this.form.subjectCount = data.subjectList.length

        for (let i = 1; i < $this.form.subjectCount; i++) {
          info['subjectList[' + (i - 1) + ']'] = data.subjectList[i].subject
        }
      }

      if (data.variables) {
        let counter = 0;
        for (const variable in data.variables) {
          $this.form.variablesCount++
          info['variable[' + (counter) + ']'] = variable;
          info['valorVariable[' + counter + ']'] = data.variables[variable];
          counter++
        }

      }
      await sleep(200);

      $this.formulario.setFieldsValue(info);

    }
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.titulo {
  font-size: 20px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 40px;
  text-align: left;
  color: #2c3e50;
}

.shadowInputs {
  box-shadow: 1px 1px 5px -5px;
  /* height: 40px; */
}

.wrapped_inputs {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ant-form-vertical .ant-form-item {
  padding-bottom: 2px
}

.formulario {
  padding: 50px 50px !important;
  border-radius: 5px;
  background-color: white;
  box-shadow: 2px 1px 5px -4px;
}

.comentarios {
  display: block;
  width: 100%;
  text-align: left;
  font-size: 13px;
  margin-top: 20px;
}
</style>

